/**
 * Maps builder color option labels to hex for summary card tinting.
 * Wheel builder: hub color + white only (never spoke). Hub/stem: their own color keys.
 * Mirrors common Industry Nine anodize names from wheelset-builder-option.liquid swatches.
 */
(function () {
  "use strict";

  var HEX = {
    black: "#141416",
    silver: "#a8a8b0",
    gold: "#c5a059",
    orange: "#e85d04",
    purple: "#7c3aed",
    green: "#059669",
    red: "#dc2626",
    bronze: "#9a6b3a",
    turquoise: "#0d9488",
    blue: "#2563eb",
    maple: "#b8956a",
    pink: "#db2777",
    "oil slick": "#2d2a32",
    "raw titanium": "#b8bdc4",
    titanium: "#b8bdc4",
    raw: "#8b8f96",
    white: "#f4f4f5",
    yellow: "#eab308",
  };

  function norm(s) {
    return String(s || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }

  function hexFor(name) {
    var k = norm(name);
    if (!k) return null;
    if (HEX[k]) return HEX[k];
    var keys = Object.keys(HEX);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (k.indexOf(key) !== -1 || key.indexOf(k) !== -1) return HEX[key];
    }
    return null;
  }

  function pick(opts, ids) {
    var a = null;
    var b = null;
    for (var i = 0; i < ids.length; i++) {
      var id = ids[i];
      var o = opts.find(function (x) {
        return x && x.id === id;
      });
      var v = o && String(o.value || "").trim();
      if (!v) continue;
      var h = hexFor(v);
      if (!h) continue;
      if (!a) a = h;
      else if (!b && h !== a) {
        b = h;
        break;
      }
    }
    return { a: a, b: b || a };
  }

  /**
   * @param {Array<{id:string,value?:string}>} completeOptions
   * @param {'hub'|'wheel'|'stem'} kind
   * @returns {Record<string, string>}
   */
  var SUMMARY_TINT_WHITE = "#ffffff";

  window.wheelbuilderSummaryTintVars = function (completeOptions, kind) {
    var opts = Array.isArray(completeOptions) ? completeOptions : [];
    var ids;
    if (kind === "wheel") {
      ids = ["hub_color", "hub_colour"];
    } else if (kind === "stem") {
      ids = ["body_color", "faceplate_color", "hub_color", "hub_colour"];
    } else {
      ids = ["hub_colour", "hub_color"];
    }
    var p = pick(opts, ids);
    if (!p.a) return {};
    /* Card torch gradients always pair hub/body accent with white (not a second anodize). */
    return {
      "--wb-summary-accent": p.a,
      "--wb-summary-accent-2": SUMMARY_TINT_WHITE,
    };
  };
})();
